import { memo, type Dispatch, type SetStateAction } from 'react';
import { CarouselContent, CarouselItem } from '@/shared/components/ui/carousel';
import type { AccountType } from '@/entities/account';
import type { UseFormReturn } from 'react-hook-form';
import type {
  AccountOption,
  AssetOption,
  InternalTransferFormValues,
  SectionType,
} from '../model';
import { type InternalAccountSectionCardType } from '../model';
import type { TransferInternalSettingsDictionary } from '@/shared/types';
import InternalTransferAccountCard from './InternalTransferAccountCard';

interface InternalAccountCarouselProps {
  accounts: InternalAccountSectionCardType[];
  assetsIconsData?: Record<string, string>;
  selectedAccountTypeFrom?: AccountType | null;
  selectedAccountTypeTo?: AccountType | null;
  selectedAssetFrom?: AssetOption | undefined;
  sectionType: SectionType;
  transferInternalSettings?: TransferInternalSettingsDictionary;
  form: UseFormReturn<InternalTransferFormValues>;
  setSelectedAssetFrom?: Dispatch<SetStateAction<AssetOption | undefined>>;
  setSelectedAssetTo?: Dispatch<SetStateAction<AssetOption | undefined>>;
  setSelectedAccountFrom?: Dispatch<SetStateAction<AccountOption | undefined>>;
  setSelectedAccountTo?: Dispatch<SetStateAction<AccountOption | undefined>>;
  accountOptions?: AccountOption[];
}

const MemoizedAccountCard = memo(InternalTransferAccountCard);

export const InternalAccountCarousel = memo(function InternalAccountCarousel({
  accounts,
  assetsIconsData,
  selectedAccountTypeFrom,
  selectedAccountTypeTo,
  selectedAssetFrom,
  sectionType,
  transferInternalSettings,
  form,
  setSelectedAssetFrom,
  setSelectedAssetTo,
  setSelectedAccountFrom,
  setSelectedAccountTo,
  accountOptions,
}: InternalAccountCarouselProps) {
  if (accounts.length === 0) {
    return null;
  }

  return (
    <CarouselContent
      className="gap-[1.6rem] w-full"
      wrapperClassName="overflow-visible">
      {accounts
        .filter(account => account.exists)
        .map(account => (
          <CarouselItem
            key={`${sectionType}_${account.type}_${account.data?.accounts?.[0]?.accNum || account.title}`}
            className="basis-auto w-full">
            <MemoizedAccountCard
              account={account}
              assetsIconsData={assetsIconsData}
              selectedAccountTypeFrom={selectedAccountTypeFrom}
              selectedAccountTypeTo={selectedAccountTypeTo}
              selectedAssetFrom={selectedAssetFrom}
              transferInternalSettings={transferInternalSettings}
              sectionType={sectionType}
              form={form}
              setSelectedAssetFrom={setSelectedAssetFrom}
              setSelectedAssetTo={setSelectedAssetTo}
              setSelectedAccountFrom={setSelectedAccountFrom}
              setSelectedAccountTo={setSelectedAccountTo}
              accountOptions={accountOptions}
            />
          </CarouselItem>
        ))}
    </CarouselContent>
  );
});
